import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ModeToggle } from '@/components/mode-toggle';
import { LogOut, User, LayoutDashboard, Shield } from 'lucide-react';
import NotificationBell from './NotificationBell';
import { useAdminNotifications } from '@/hooks/useAdminNotifications';

export default function Header() {
  const { currentUser, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const adminNotifications = useAdminNotifications(!!userProfile?.isAdmin);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="border-b border-border bg-background">
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <Link to={currentUser ? '/dashboard' : '/'} className="flex items-center space-x-2">
          <img 
            src="/logo.png" 
            alt="Dining Steward Logo" 
            className="h-8 w-8"
          />
          <span className="text-xl font-bold text-navy dark:text-foreground">Dining Steward</span>
        </Link>

        <div className="flex items-center space-x-2 sm:space-x-4">
          {currentUser ? (
            <>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate('/dashboard')}
                title="Dashboard"
              >
                <LayoutDashboard className="h-5 w-5" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate('/settings')}
                title="Personal Settings"
              >
                <User className="h-5 w-5" />
              </Button>
              <NotificationBell />
              {userProfile?.isAdmin && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    const adminUrl = import.meta.env.VITE_ADMIN_URL || 'http://localhost:3004';
                    const baseUrl = adminUrl.replace(/\/$/, ''); // Remove trailing slash if present
                    window.location.href = `${baseUrl}/dashboard`;
                  }}
                  title="Admin Dashboard"
                  className="relative"
                >
                  <Shield className="h-5 w-5" />
                  {adminNotifications.total > 0 && (
                    <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
                      {adminNotifications.total > 9 ? '9+' : adminNotifications.total}
                    </span>
                  )}
                </Button>
              )}
              <ModeToggle />
              <Button variant="ghost" size="icon" onClick={handleLogout} title="Logout">
                <LogOut className="h-5 w-5" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="outline" onClick={() => navigate('/login')}>
                Log In
              </Button>
              <Button variant="default" onClick={() => navigate('/signup')}>
                Sign Up
              </Button>
              <ModeToggle />
            </>
          )}
        </div>
      </div>
    </header>
  );
}

